import React from 'react';
import { FaTimes } from 'react-icons/fa';

const API_URL = '/api';

const ClientViewModal = ({ open, onClose, client }) => {
  if (!open || !client) return null;

 return (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 px-4">
    <div className="bg-[#E5E1DA] rounded-2xl shadow-2xl w-full max-w-3xl p-4 sm:p-6 md:p-8 relative overflow-y-auto max-h-[90vh]">
      
      {/* Close Button */}
      <button 
        className="absolute top-3 right-3 text-[#2b6777] hover:text-[#52ab98]" 
        onClick={onClose}
      >
        <FaTimes size={20} />
      </button>
      
      {/* Title */}
      <h2 className="text-xl sm:text-2xl font-bold text-[#2b6777] mb-4 sm:mb-6 text-center">
        Client Details
      </h2>

      <div className="space-y-4 sm:space-y-6">
        
        {/* Client Info Section */}
        <div className="bg-white rounded-xl p-4 sm:p-6">
          <h3 className="text-base sm:text-lg font-bold text-[#2b6777] mb-3 sm:mb-4">
            Client Information
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
            <div>
              <span className="text-xs sm:text-sm font-medium text-gray-600">Company Name:</span>
              <span className="block text-sm sm:text-base text-gray-900 mt-1">{client.company_name}</span>
            </div>
            <div>
              <span className="text-xs sm:text-sm font-medium text-gray-600">Email:</span>
              <span className="block text-sm sm:text-base text-gray-900 mt-1 break-all">{client.email_id}</span>
            </div>
            <div>
              <span className="text-xs sm:text-sm font-medium text-gray-600">Mobile:</span>
              <span className="block text-sm sm:text-base text-gray-900 mt-1 break-all">{client.mobile_no}</span>
            </div>
            <div>
              <span className="text-xs sm:text-sm font-medium text-gray-600">Vendor:</span>
              <span className="block text-sm sm:text-base text-gray-900 mt-1">{client.vendor_name || '-'}</span>
            </div>
            <div>
              <span className="text-xs sm:text-sm font-medium text-gray-600">Status:</span>
              <span
                className={`inline-block mt-1 px-2 sm:px-3 py-1 rounded-full text-[10px] sm:text-xs font-bold shadow-sm
                  ${client.status === 'Active'
                    ? 'bg-[#52ab98] text-white'
                    : 'bg-gray-300 text-gray-500'}`}
              >
                {client.status}
              </span>
            </div>
          </div>
        </div>

        {/* Logo Section */}
        <div className="bg-white rounded-xl p-4 sm:p-6 flex flex-col sm:flex-row items-center gap-3 sm:gap-4">
          <span className="text-sm sm:text-lg font-bold text-[#2b6777]">Company Logo:</span>
          {client.client_id ? (
            <img
              src={`/api/clients/${client.client_id}/logo?${Date.now()}`}
              alt="Logo"
              className="h-14 sm:h-16 rounded shadow"
              onError={e => { e.target.onerror = null; e.target.src = ''; }}
            />
          ) : (
            <span className="text-gray-400 text-xs sm:text-sm">No logo uploaded</span>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="mt-4 sm:mt-6 flex justify-center sm:justify-end">
        <button 
          className="px-4 py-2 rounded bg-[#52ab98] hover:bg-[#2b6777] text-white font-semibold shadow transition text-sm sm:text-base"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  </div>
);

};

export default ClientViewModal; 